import React, { useState, useEffect } from 'react';

import { TEMPERATURE_BY_GROUP_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { addOption, removeOption, normalizeGroupedOptions } from '../helpers';
import { useFilterCount } from '../hooks/useFilterCount';

export const TagsSelectPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();

  const [allOptions, setAllOptions] = useState(TEMPERATURE_BY_GROUP_OPTIONS.raw);
  const [createdOptions, setCreatedOptions] = useState([]);
  const selectedTags = useWatch({ name: 'tags' }) || [];
  const { control } = useFormContext();

  useEffect(() => {
    // при инициализации смотрим есть ли в форме уже добавленные опции
    const initialCreated = selectedTags.filter(
      (option) => !TEMPERATURE_BY_GROUP_OPTIONS.raw.some((c) => c.value === option.value),
    );
    setCreatedOptions(normalizeGroupedOptions(initialCreated));
  }, []);

  useEffect(() => {
    setAllOptions([...createdOptions, ...TEMPERATURE_BY_GROUP_OPTIONS.raw]);
  }, [createdOptions]);

  const filterCount = Array.isArray(selectedTags) && selectedTags.length > 0 ? 1 : 0;
  useFilterCount('tags', filterCount, onCountChange);

  const onCreateOption = (option) => {
    setCreatedOptions((prev) => addOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  const onDeleteOption = (option) => {
    setCreatedOptions((prev) => removeOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="tagsFilter"
      triggerValue={t('tags')}
    >
      <CheckboxCustomFilter
        control={control}
        createdOptions={createdOptions}
        isCreatable
        isMulti
        isSearchable
        name="tags"
        onCreateOption={onCreateOption}
        onDeleteOption={onDeleteOption}
        options={allOptions}
      />
    </CustomFilterPopover>
  );
};
